import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedUniqueDefDestinationTable,
  setSelectedUniqueDefID,
  setSelectedUniqueDefInterfaceName,
} from "../../../../features/uniqueDefSlice";

const UniqueDefinitionsFilter = () => {
  const {
    selectedUniqueDefID,
    selectedUniqueDefInterfaceName,
    selectedUniqueDefDestinationTable,
    uniqueDefinitionDataAll,
  } = useSelector((state: any) => state.uniqueDefinition);
  const dispatch = useDispatch();
  const [searchDefinitionID, setSearchDefinitionID] = useState("");
  const [searchInterfaceName, setSearchInterfaceName] = useState("");
  const [searchDestinationTable, setSearchDestinationTable] = useState("");

  const filterConfig = [
    {
      key: "Definition ID",
      label: "Select one or more Definitions",
      searchTerm: searchDefinitionID,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchDefinitionID(e.target.value),
      selectedOption: selectedUniqueDefID,
      filterName: "id",
      data: uniqueDefinitionDataAll,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedUniqueDefID(updatedSelection)),
      count: selectedUniqueDefID && selectedUniqueDefID.length,
      colorSelected:
        selectedUniqueDefID !== null && selectedUniqueDefID.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Interface Name",
      label: "Select one or more Interface Names",
      searchTerm: searchInterfaceName,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchInterfaceName(e.target.value),
      selectedOption: selectedUniqueDefInterfaceName,
      filterName: "affiliate_system_interface",
      data: uniqueDefinitionDataAll,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedUniqueDefInterfaceName(updatedSelection)),
      count:
        selectedUniqueDefInterfaceName && selectedUniqueDefInterfaceName.length,
      colorSelected:
        selectedUniqueDefInterfaceName !== null &&
        selectedUniqueDefInterfaceName.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Destination Table",
      label: "Select one or more Destination Tables",
      searchTerm: searchDestinationTable,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchDestinationTable(e.target.value),
      selectedOption: selectedUniqueDefDestinationTable,
      filterName: "destination_table_name",
      data: uniqueDefinitionDataAll,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedUniqueDefDestinationTable(updatedSelection)),
      count:
        selectedUniqueDefDestinationTable &&
        selectedUniqueDefDestinationTable.length,
      colorSelected:
        selectedUniqueDefDestinationTable !== null &&
        selectedUniqueDefDestinationTable.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedUniqueDefID(null));
    dispatch(setSelectedUniqueDefInterfaceName(null));
    dispatch(setSelectedUniqueDefDestinationTable(null));
    setSearchDefinitionID("");
    setSearchInterfaceName("");
    setSearchDestinationTable("");
  };
  return (
    <Box data-tracker="358">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default UniqueDefinitionsFilter;
